import BaseStack from './BaseStack';
import SdpHelpers from './../utils/SdpHelpers';
import Logger from '../utils/Logger';
const ChromeStableStack = (specInput) => {
    Logger.info('Starting Chrome stable stack', specInput);
    const spec = specInput;
    const that = BaseStack(specInput);
    const defaultSimulcastSpatialLayers = 2;
    that.enableSimulcast = (sdpInput) => {
        let result;
        let sdp = sdpInput;
        if (!that.simulcast) {
            return sdp;
        }
        // TODO(javier): Improve the way we check for current video ssrcs
        const matchGroup = sdp.match(/a=ssrc-group:FID ([0-9]*) ([0-9]*)\r?\n/);
        if (!matchGroup || (matchGroup.length <= 0)) {
            return sdp;
        }
        // TODO (pedro): Consider adding these to SdpHelpers
        const numSpatialLayers = that.simulcast.numSpatialLayers || defaultSimulcastSpatialLayers;
        const baseSsrc = parseInt(matchGroup[1], 10);
        const baseSsrcRtx = parseInt(matchGroup[2], 10);
        const cname = sdp.match(new RegExp(`a=ssrc:${matchGroup[1]} cname:(.*)\r?\n`))[1];
        const msid = sdp.match(new RegExp(`a=ssrc:${matchGroup[1]} msid:(.*)\r?\n`))[1];
        const mslabel = sdp.match(new RegExp(`a=ssrc:${matchGroup[1]} mslabel:(.*)\r?\n`))[1];
        const label = sdp.match(new RegExp(`a=ssrc:${matchGroup[1]} label:(.*)\r?\n`))[1];
        sdp.match(new RegExp(`a=ssrc:${matchGroup[1]}.*\r?\n`, 'g')).forEach((line) => {
            sdp = sdp.replace(line, '');
        });
        sdp.match(new RegExp(`a=ssrc:${matchGroup[2]}.*\r?\n`, 'g')).forEach((line) => {
            sdp = sdp.replace(line, '');
        });
        const spatialLayers = [baseSsrc];
        const spatialLayersRtx = [baseSsrcRtx];
        for (let i = 1; i < numSpatialLayers; i += 1) {
            spatialLayers.push(baseSsrc + (i * 1000));
            spatialLayersRtx.push(baseSsrcRtx + (i * 1000));
        }
        result = SdpHelpers.addSim(spatialLayers);
        let spatialLayerId;
        let spatialLayerIdRtx;
        for (let i = 0; i < spatialLayers.length; i += 1) {
            spatialLayerId = spatialLayers[i];
            spatialLayerIdRtx = spatialLayersRtx[i];
            result += SdpHelpers.addGroup(spatialLayerId, spatialLayerIdRtx);
        }
        for (let i = 0; i < spatialLayers.length; i += 1) {
            spatialLayerId = spatialLayers[i];
            spatialLayerIdRtx = spatialLayersRtx[i];
            result += SdpHelpers.addSpatialLayer(cname, msid, mslabel, label, spatialLayerId, spatialLayerIdRtx);
        }
        result += 'a=x-google-flag:conference\r\n';
        return sdp.replace(matchGroup[0], result);
    };
    that.setStartVideoBW = (sdpInfo) => {
        if (that.video && spec.startVideoBW) {
            Logger.debug(`startVideoBW requested: ${spec.startVideoBW}`);
            SdpHelpers.setParamForCodecs(sdpInfo, 'video', 'x-google-start-bitrate', spec.startVideoBW);
        }
    };
    that.setHardMinVideoBW = (sdpInfo) => {
        if (that.video && spec.hardMinVideoBW) {
            Logger.debug(`hardMinVideoBW requested: ${spec.hardMinVideoBW}`);
            SdpHelpers.setParamForCodecs(sdpInfo, 'video', 'x-google-min-bitrate', spec.hardMinVideoBW);
        }
    };
    return that;
};
export default ChromeStableStack;
//# sourceMappingURL=ChromeStableStack.js.map